<template>
    <div class="idle-indicator w-100" v-show="show()" :key="messageId + '-' + tick">
        <a-divider class="idle">{{ time() }}</a-divider>
        <span class="idle-desc" v-if="tookTimeInSeconds() < 60">{{ $t("auto.chatIdleDueToOneMinute") }}</span>
        <span class="idle-desc" v-else>{{ $t("chart.chatIdleDueToMinutes", { n: tookTimeInMinutes() }) }}</span>
    </div>
</template>
<script>
import moment from "moment";
import { log2 } from "../../../utils/log2";
import { mapState } from "vuex";
import _ from "lodash";

const { generateUUID } = require("../../../utils/session");
const log = log2("IdleIndicatorMessage");
export default {
    data() {
        return {
            tick: 1,
            messageId: generateUUID(),
        };
    },
    computed: {
        ...mapState({
            inactiveThresholdTime: (state) => _.get(state.setting.settings, "inactiveThresholdTime", 5) * 60,
        }),
    },
    props: {
        startTimestamp: {
            type: Number,
            required: true,
        },
        isLive: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        time() {
            return moment(this.startTimestamp).format("LTS");
        },
        tookTimeInSeconds() {
            return moment().diff(moment(this.startTimestamp), "seconds");
        },
        tookTimeInMinutes() {
            return moment().diff(moment(this.startTimestamp), "minute");
        },
        show() {
            // log("show", {
            //     isLive: this.isLive,
            //     tookTimeInSeconds: this.tookTimeInSeconds(),
            //     inactiveThresholdTime: this.inactiveThresholdTime,
            //     result: this.isLive ? this.tookTimeInSeconds() >= this.inactiveThresholdTime * 0.95 : true,
            // });

            return this.isLive ? this.tookTimeInSeconds() >= this.inactiveThresholdTime * 0.95 : true;
        },
    },
    mounted() {
        log("mounted", {
            startTimestamp: this.startTimestamp,
            isLive: this.isLive,
        });
        if (this.isLive) {
            this.timerId = setInterval(() => {
                this.tick++;
            }, 5000);
        }
    },
    beforeDestroy() {
        if (this.timerId) clearInterval(this.timerId);
    },
};
</script>
<style lang="scss">
.idle-indicator {
    .idle-desc {
        width: 100%;
        display: flex;
        justify-content: center;
        color: #8a8a8a;
        font-size: 12px;
    }

    .ant-divider-horizontal.ant-divider-with-text-center {
        margin: 3px 0px;
    }
}

.idle.ant-divider {
    span.ant-divider-inner-text {
        font-size: 12px !important;
        color: #8a8a8a !important;
    }
}
</style>
